export type SignUpSteps = 'method' | 'consent' | 'verify';

export type SignUpMethods = 'google' | 'email';

export const SIGN_UP_STEP_CONFIG: Record<SignUpSteps, { layout: 'single' | 'dual'; getTitle: (hasInvitation: boolean) => string }> = {
  method: {
    layout: 'dual',
    getTitle: (hasInvitation) => hasInvitation ? 'Join your team on CoinGate' : 'Setup business account',
  },
  consent: {
    layout: 'dual',
    getTitle: (hasInvitation) => hasInvitation ? 'Join your team on CoinGate' : 'Setup business account',
  },
  verify: {
    layout: 'single',
    getTitle: () => 'Check your email',
  },
};

export type ProfileSetUpSteps = 'password' | 'aboutYou' | 'aboutYourBusiness';

export const PROFILE_SET_UP_STEP_CONFIG: Record<ProfileSetUpSteps, { layout: 'single' | 'dual'; title: string }> = {
  password: {
    layout: 'single',
    title: 'Create password',
  },
  aboutYou: {
    layout: 'single',
    title: 'About you',
  },
  aboutYourBusiness: {
    layout: 'single',
    title: 'About your business',
  },
};

export const TERMS_OF_SERVICE_LINK = 'https://coingate.com/legal-documents';
export const PRIVACY_POLICY_LINK = 'https://coingate.com/policy/privacy-policy';
export const GIFT_CARDS_LINK = 'https://coingate.com/gift-cards';
export const MERCHANT_DIRECTORY_LINK = 'https://coingate.com/stores?source=signup';
